<template>
    <modal name="member-delivery-modal" class="order-delivery-modal member-delivery-modal"
           :width="'30%'"
           :height="'auto'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="keymodal_title">
            <div class="out_title">배송지 수정</div>
        </div>
        <div class="order_delivery_wrap">
            <delivery-write-member-component :deliveryData="deliveryData"></delivery-write-member-component>
            <div class="text_center pt20">
                <el-button type="primary" class="out_btn" @click="save">저장</el-button>
                <el-button type="info" class="out_btn" @click="modalClose()">취소</el-button>
            </div>
        </div>
    </modal>
</template>

<script>
import util from '@/mixins/util';
import DeliveryWriteMemberComponent from '@/components/delivery/DeliveryWriteMemberComponent.vue';
import EventBus from "@/mixins/event-bus";

export default {
    name: "MemberDeliveryModal",
    props: {},
    mixins: [],
    components: {DeliveryWriteMemberComponent},
    computed: {},
    provide() {
        return {
        }
    },
    data() {
        return {
            deliveryData:{},
        }
    },
    mounted() {
    },
    methods: {
        handlerBeforeOpen(event) {
            if(!util.isEmpty(event.params)){
                if(event.params.hasOwnProperty('deliveryData') && !util.isEmpty(event.params.deliveryData)){
                    this.deliveryData = event.params.deliveryData
                }               
            }
        },
        handlerOpened() {
        },
        handlerBeforeClose() {
            this.deliveryData = {}
        },
        modalClose() {
            this.$modal.hide('member-delivery-modal');
        },
        save(){
            EventBus.$emit('writeMemberDelivery')
        }

    }
}
</script>

<style scoped>

</style>